<template>
  <div id="Opportunities_RecreationalSports">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro"><i>Trojan athletics extends beyond our award-winning varsity athletes to include all students interested in working out, swimming laps or trying their hand at a new martial art or club sport.</i></usc-intro>
    <div class="body gutter-lg mb">
      <p>Multiple fitness centers include the Lyon Recreation Center and adjacent Uytengsu Aquatics Center as well as the USC Village Fitness Center. Other recreational sports facilities include two outdoor turf fields, an indoor swimming pool, outdoor basketball court, and tennis and racquetball courts. </p>
    </div>
    <usc-twoColumns>
      <h3 slot="fullWidth">Club Sports</h3>
      <p slot="fullWidth">The USC Club Sports consists of more than 50 student-run organizations that compete in intercollegiate events for various sports and activities. <a href="https://recsports.usc.edu/programs-classes/competitive-sports/club-sports/" class="inline-hyperlink" target="_blank">Learn more about current clubs</a> and how to join. </p>
      <p slot="fullWidth">Current clubs include:</p>
      <ul slot="left">
        <li>Archery</li>
        <li>Badminton</li>
        <li>Ballroom/Latin Dance</li>
        <li>Barbell</li>
        <li>Basketball (men’s and women’s)</li>
        <li>Beach volleyball</li>
        <li>Brazilian jiu jitsu</li>
        <li>Chaotic 3</li>
        <li>Cheer</li>
        <li>Chess</li>
        <li>Climbing</li>
        <li>Crew</li>
        <li>Cricket</li>
        <li>Cycling</li>
        <li>Dragon Boat</li>
        <li>Equestrian</li>
        <li>Fencing</li>
        <li>Field Hockey</li>
        <li>Figure Skating</li>
        <li>Futsal</li>
        <li>Golf</li>
        <li>Gymnastics</li>
      </ul>
      <ul slot="right">
        <li>Ice Hockey</li>
        <li>Kendo</li>
        <li>Kung Fu</li>
        <li>Lacrosse (men’s and women’s)</li>
        <li>Ping Pong</li>
        <li>Polo</li>
        <li>Rugby (men’s and women’s)</li>
        <li>Shinkendo</li>
        <li>Soccer (men’s and women’s)</li>
        <li>Softball</li>
        <li>Soul Cal Breaking</li>
        <li>Swim</li>
        <li>Taekwondo</li>
        <li>Tennis</li>
        <li>Track</li>
        <li>Triathlon</li>
        <li>Ultimate frisbee (men’s and women’s)</li>
        <li>Underwater Torpedo</li>
        <li>Volleyball (men’s and women’s)</li>
        <li>Water polo (men’s and women’s)</li>
        <li>Wrestling</li>
      </ul>
    </usc-twoColumns>
    <usc-twoColumns>
      <h3 slot="fullWidth">Intramural Sports</h3>
      <p slot="fullWidth">The Intramural Sports program is one of the most popular undergraduate and graduate student activities at USC, with more than 9,600 participants. Intramural sports promote physical fitness and competition, social interaction and student involvement. Sign up as a team or individual. Groups and individuals are encouraged to participate regardless of skill level.</p>
      <p slot="fullWidth">Sports include:</p>
      <ul slot="left">
        <li>3x3 Basketball</li>
        <li>Baseball</li>
        <li>Dodgeball</li>
        <li>Golf</li>
        <li>Pickleball</li>
        <li>Pac-10 Competitions</li>
        <li>Soccer</li>
        <li>Swim Meet</li>
        <li>Volleyball</li>
      </ul>
      <ul slot="right">
        <li>5k Spring Run</li>
        <li>Basketball</li>
        <li>Flag Football</li>
        <li>Inner Tube Water Polo</li>
        <li>Racquetball</li>
        <li>Softball</li>
        <li>Tennis</li>
        <li>Community</li>
      </ul>
    </usc-twoColumns>
    <div class="body mb gutter-lg">
     <p><strong>Community Outreach</strong><br />USC Recreational Sports is affiliated with several community outreach programs, all of which provide sports and educational opportunities for youngsters in our neighborhood. These include the:</p>
     <ul>
      <li>Federally funded National Youth Sports Program, which provides summer instruction in sports for youngsters 10 to 16 years old</li>
      <li>Trojan Kids Camp, which operates in conjunction with the National Youth Sports Program during the summer to provide additional supervision and sports activities for children 10 to 16 years old</li>
      <li>After-School Sports Connection, which offers both after-school sports instruction to students in the third through fifth grades and summer swim lessons through a partnership with Kids in Sports of Los Angeles</li>
     </ul>
    </div>
  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import videoEmbed from '@/components/videoEmbed'
import twoColumns from '@/components/TwoColumns'

export default {
  name: 'RecreationalSports',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-videoEmbed': videoEmbed,
    'usc-twoColumns': twoColumns
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Recreational Sports',
        loResSrc: '../../../static/HeroImages/Marshall43.png',
        hiResSrc: '../../../static/HeroImages/Marshall43.png'
      },
      intro: [
        ''
      ],
      video: {
        caption: 'Combining a love of playing sports with a new passion for Sports Management',
        src: 'https://player.vimeo.com/video/249455011?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Sports Management'
      }
    }
  },
  created () {
    this.$root.setPageHeader('Opportunities', 'Recreational Sports')
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/life-at-marshall/RecreationalSports.vue